export function redirectToThreadsAuthPage({
  isReconnect,
  skedAccountId,
}:
  | {
      isReconnect: true;
      skedAccountId: string;
    }
  | {
      isReconnect: false;
      skedAccountId?: string;
    }): string {
  let url = "/threads/request_token";

  if (isReconnect) {
    if (!skedAccountId) {
      throw new Error("accountId is required when reconnecting");
    }
    url = `${url}?reconnect=true&accountId=${skedAccountId}`;
  }
  return url;
}
